export const DAY_VARIANTS = {
  TODAY: "today",
  SELECTED: "selected",
  START: "start",
  END: "end",
  BETWEEN: "between",
};

export const DATE_FORMAT = "YYYY-MM-DD";

export const WEEK = {
  SU: 0,
  MO: 1,
  TU: 2,
  WE: 3,
  TH: 4,
  FR: 5,
  SA: 6,
};

export const SIZES = {
  SMALL: "small",
  REGULAR: "regular",
  LARGE: "large",
};

export const VARIANTS = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
};

export const TYPES = {
  NAV: {
    NEXT: "next",
    PREV: "prev",
  },
};
